type Gender = 'masculin' | 'feminin' | ''
type Personne = 'moral' | 'physique'


export class User {
  id : string = ""
  name : string = ""
  email : string = ""
  gender : Gender = "masculin"
  tel : string = ""
  adresse : string = ""
  disable : boolean = false
  site : Site = new Site()
  profil : any
  change_password : boolean = false
  compagnie_id : string = ""
}

export class Collaborateur {
  id : string = ""
  code : string = ""
  name : string = ""
  owner : string = ""
  adresse : string = ""
  logo : string = ""
  tel : string = ""
  email : string = ""
  niu : string = ""
  rccm : string = ""
  capital : string = ""
  agrement : string = ""
  bp : string = ""
  disable : boolean = false
}

export class Collaboration{
  id : string = ""
  collaborateur_id : string = ""
  collaborateur_name : string =""
  site_id : string = ""
  site_name : string = ""
  logo : string = ""
  adresse : string = ""
  owner :string = ""
  active : boolean = false
  code : string = ""
}

export class Site {
  id : string = ""
  name : string = ""
  owner : string = ""
  adresse : string = ""
  disable : boolean = false
  groupe_id : string = ""
  groupe_name : string = ""
}

export class Profil {
  id : string = ""
  name : string = ""
}

export class Compagnie {
  id : string = ""
  name : string = ""
  code : string = ""
  logo : string = ""
  forme : string = ""
  capital : string = ""
  niu : string = ""
  rccm : string = ""
  agrement : string = ""
  adresse : string = ""
  bp : string = ""
  tel : string = ""
  email : string = ""
  description : string = ""
  disable : boolean = false
}


//////

type Hposition = 'center' | 'left' | 'right' | 'end' | 'start'
type VPosition = 'bottom' | 'top'
type ClassName = 'info' | 'success' | 'error' | 'warn' | ''

export class
DataSnackBar{
  message : string = ""
  close ?:boolean = false
  nameCloseAction ?: string = "fermer"
  class ?: ClassName = ""
  duration ?: number
  horizontalPosition?: Hposition = 'end'
  verticalPosition?: VPosition = 'bottom'
}


export class Partenaire {
  id : string = ""
  join : boolean = false
  code_partenaire : string  = ""
  categorie : string = ""
  format_police : string = ""
  collaborateur_id : string = ""
  collaborateur_name : string = ""
  collaborateur_code : string = ""
  collaborateur_owner : string = ""
  collaborateur_adresse : string = ""
  collaborateur_logo : string = ""
  compagnie_id : string = ""
  compagnie_name : string = ""
  compagnie_logo : string = ""
  document_reste : number = 0
}

export class Assure {
  id : string = ""
  firstname : string = ""
  lastname : string = ""
  gender : Gender = ""
  personne : Personne = "physique"
  niu : string = ""
  tel : string = ""
  email : string = ""
  adresse : string = ""
  profession : string = ""
  nif : string = ""
  societe : string = ""
  rc : string = ""
  representant : string = ""
  forme_juridique : string = ""
  vehicules : Vehicule[] = []
}

export class Vehicule {
  id : string = ""
  immatriculation : string = ""
  marque : string = ""
  model : string = ""
  genre : string = ""
  chassis : string = ""
  energie : string = ""
  date_circulation : string = ""
  puissance : number = 0
  cylindree : number = 0
  status : string = ""
  place : number = 5
  charge_utile : number = 0
  charge_vide : number = 0
  last_editor : string = ""
  assure_id : string = ""
  assurance : boolean = false
  assurance_id : string = ""
  assurance_suspendu : boolean = false
  remorque : boolean = false
  tracteur_id : string = ""
  assurance_remorque ?: string = ""
  categorie :string = ""
  zone :string = ""
  periode : number = 0
  compagnie_id : string = ""
  compagnie_name : string = ""
}


export class Distribution{
  id : string = ""
  type : string =""
  attestation_range : string = ""
  carte_rose_range : string = ""
  qte : number = 0
  reste : number = 0
  partenaire_id : string = ""
  compagnie_name : string = ""
  compagnie_id : string = ""
  collaborateur_id : string = ""
  collaborateur_name : string = ""
}

export interface DistributionDataI{
  compagnies : [{compagnie_id : string, compagnie_name : string}]
  types : [{type : string, compagnie_id : string}]
  distributions ?: Distribution[],
  stock_groupe ?: StockGroupe[],
  stock ?: Stock[]
}

export class Stock{
  id : string = ""
  attestation_range : string = ""
  attestation_used : string = ""
  carte_rose_range : string = ""
  carte_rose_used : string = ""
  qte : number = 0
  reste : number = 0
  type : string =""
  partenaire_id : string = ""
  stock_groupe_id : string = ""
  site_id : string = ""
  compagnie_id : string =""
  compagnie_name : string = ""
  collaborateur_id : string = ""
  collaborateur_name : string = ""
}


export class StockGroupe{
  id : string = ""
  attestation_range : string = ""
  attestation_used : string = ""
  carte_rose_range : string = ""
  carte_rose_used : string = ""
  qte : number = 0
  reste : number = 0
  type : string =""
  partenaire_id : string = ""
  distribution_id : string = ""
  groupe_id : string = ""
  compagnie_id : string =""
  compagnie_name : string = ""
  collaborateur_id : string = ""
  collaborateur_name : string = ""
}

export interface ListItem {
  id : string
  name : string
  details ?: string
  selected ?: boolean
  disabled? : boolean
  hide?:boolean
}

export class ModalListItemI{
  title : string = ""
  data : any[] = []
  multi?:boolean
  action ?: string
}

export interface TarificationCheck{
  categorie : string,
  energie : string,
  puissance : number,
  cylindree : number
  zone : string,
  garanties ?: GarantieI[],
  place ?: number,
  charge ?: number,
  periode : string,
  reduction : number
}

export interface Tarification{
  categorie : string,
  energie : string,
  puissance : number,
  cylindree : number
  zone : string,
  garanties ?: GarantieI[],
  place ?: number,
  charge ?: number,
  periode : string,
  reduction : number
}


export interface GarantieI {
  id : string,
  name : string,
  abbreviation : string,
  selected : boolean,
  status : boolean
}

export class Prime {
  dta : number = 0
  carte_rose : number = 0
  prime_nette : number = 0
  tva : number = 0
  prime_ttc : number = 0
}

export class Assurance{
  id : string = ""
  police : string = ""
  date_effet : string = ""
  periode : string = ""
  date_fin : string = ""
  vignette : number = 0
  vehicule_id : string = ""
  categorie : number = 0
  zone : string = ""
  created_at : string =""
  last_editor : string =""
  last_editor_name : string =""
  attestation : number = 0
  carte_rose : number = 0
  type : string = ""
  compagnie_id : string = ""
  assure_id : string = ""
  conducteur_id : string = ""
  conducteur ?: Conducteur = new Conducteur()
  tarification_id : string = ""
  collaborateur_id : string = ""
  suspendu : boolean = false
  avenants : Avenant[] = []
}


export interface ListeDocs{
  compagnies : [{compagnie_id : string, compagnie_name : string, compagnie_code : string}],
  types : [{compagnie_id : string, type : string}]
  stocks : Stock[]
}

export class Avenant{
  id : string = ""
  name : string = ""
  editor : string = ""
  editor_name : string = ""
  created_at : string = ""
  assurance_id : string = ""
  new_periode ?: number = 0
}

export class Conducteur{
  name : string = ""
  genre : string =""
  birthday : string = ""
  num_permis : string = ""
  date_delivrance : string = ""
  lieu_delivrance : string = ""
}


export class Remorque {
  id : string = ""
  immatriculation : string = ""
  carte_grise : string =""
  chassis : string = ""
  ptac : string = ""
  ptra : string = ""
  poids_vide : number = 0
  vehicule_id : string = ""
  assurance_id : string = ""
  editor : string = ""
}

export class PrintData {
  assurance : string = ""
  name : string = ""
  path ?: string = ""
  dataBlob ?: Blob
  timeout ?: boolean = false 
  detail ?: string = ""
}
